import { LocationVarInheritance } from "@swivl-mono/types";

export const REVERT_TO_DEFAULT = "Revert to Default";
export const REVERT_TO_PARENT = "Revert to Parent";

interface RevertLabelArgs {
  /** Org is the top scope — nothing above it to inherit from. */
  isOrgScope: boolean;
  /** This row is saved as an override at the current scope. */
  isOverride: boolean;
  /** How the row resolves today. */
  inheritance: LocationVarInheritance;
  /** How the next scope up resolves — where a revert would land. */
  parentInheritance: LocationVarInheritance | undefined;
}

/**
 * What the revert button should be called, based on where the value actually
 * lands. Reverting always does the same thing — drop the override at this scope
 * and let the cascade resolve again — but the result is either a parent scope's
 * value or the built-in default, and the button should say which.
 *
 * For a saved override, today's inheritance is NONE and says nothing about
 * what's above, so the destination comes from the parent scope's resolution
 * instead. For a staged-only edit the row is still showing its inherited value,
 * so its own inheritance is already the answer.
 */
export function revertLabelFor({ isOrgScope, isOverride, inheritance, parentInheritance }: RevertLabelArgs): string {
  if (isOrgScope) return REVERT_TO_DEFAULT;
  const target = isOverride ? parentInheritance : inheritance;
  return target === undefined || target === LocationVarInheritance.DEFAULT ? REVERT_TO_DEFAULT : REVERT_TO_PARENT;
}
